//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "TheRadarBadge",

  props: {
    styles: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    computedStyles() {
      return {
        ...this.styles
      };
    },
  },
}
